// src/layout/Footer.jsx
import React from "react";

const sizeMap = {
  sm: "h-10 text-xs",
  md: "h-14 text-sm",
  lg: "h-16 text-base",
};

export function Footer({
  size = "md",
  start = null,
  center = null,
  end = null,
  className = "",
  sticky = true, // footers often aren’t sticky; make it an option
}) {
  const sz = sizeMap[size] ?? sizeMap.md;
  return (
    <footer
      className={["row", "align-items-center", sz, className].join(" ")}
      role="contentinfo"
    >
      <div className="w-100 d-flex justify-content-between align-items-center">
        {/*w-100 mx-auto mx-xl-auto px-4 row align-items-center justify-content-between gap-3"> */}
        {start}
        {center}
        {end}
      </div>
    </footer>
  );
}
